import {ItemQuantity} from "./Inventory";
import {CRAFTING_RECIPES, CraftingRecipe} from "./CraftingRecipes";

export type AssemblyRecipe = {
    id: string;
    name: string;
    ingredients: ItemQuantity[];
    result: ItemQuantity;
    durationMs: number;
    description?: string;
};

const assemblyCapableRecipes = CRAFTING_RECIPES.filter(recipe => recipe.availableInAssembly !== false);

const recipeToAssembly = (recipe: CraftingRecipe): AssemblyRecipe => {
    const durationMs = recipe.assemblyDurationMs ?? recipe.durationMs;
    return {
        id: recipe.assemblyId ?? `assembly-${recipe.result.itemId}`,
        name: recipe.name,
        ingredients: recipe.ingredients,
        result: recipe.result,
        durationMs,
        description: recipe.description,
    };
};

export const ASSEMBLY_RECIPES: Record<string, AssemblyRecipe> = assemblyCapableRecipes.reduce<Record<string, AssemblyRecipe>>((acc, recipe) => {
    const assemblyRecipe = recipeToAssembly(recipe);
    acc[assemblyRecipe.id] = assemblyRecipe;
    return acc;
}, {});

export const ASSEMBLY_RECIPE_LIST = Object.values(ASSEMBLY_RECIPES);
